<template>
  <form novalidate @submit.prevent="submit">
    <header class="modal-header">Where on the property?</header>
    <section class="modal-body">
      <LsCheckboxes
        v-model="locations"
        :options="options"
        test-id="quality"
        track-id="return_request_location-locations"
        name="locations"
        :validation="{ required: true }"
        columns
      />
    </section>
    <footer class="modal-footer">
      <LsButton
        type="submit"
        text="next"
        track-id="return_request_location-next"
        :loading="dispute.loadingStatus.isUpdating"
      />
    </footer>
  </form>
</template>

<script>
import { LsButton, LsCheckboxes } from '@/components/common';
import { mapState, mapActions } from 'vuex';
import { DISPUTE__UPDATE_CURRENT_DISPUTE, DISPUTE__SUBMIT_DISPUTE } from '@/store/types';
import _ from 'lodash';

export default {
  name: 'ReturnRequestLocation',
  components: {
    LsButton,
    LsCheckboxes,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      options: [
        {
          value: 'full_yard',
          label: 'Full yard',
        },
        {
          value: 'front_yard',
          label: 'Front yard',
        },
        {
          value: 'left_yard',
          label: 'Left side',
        },
        {
          value: 'back_yard',
          label: 'Back yard',
        },
        {
          value: 'right_yard',
          label: 'Right side',
        },
        {
          value: 'other_yard',
          label: 'Other',
        },
      ],
      locations: [],
    };
  },
  computed: {
    ...mapState(['dispute']),
  },
  methods: {
    ...mapActions([DISPUTE__UPDATE_CURRENT_DISPUTE, DISPUTE__SUBMIT_DISPUTE]),
    async submit() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        return;
      }

      const locations = {};
      _.forEach(this.locations, (location) => {
        locations[location] = true;
      });

      if (locations.other_yard || this.dispute.currentDispute.reason === 'other') {
        this[DISPUTE__UPDATE_CURRENT_DISPUTE]({
          currentStep: 'ReturnRequestNotes',
          ...locations,
        });
      } else {
        this[DISPUTE__UPDATE_CURRENT_DISPUTE]({
          currentStep: 'ReturnRequestPhotos',
          ...locations,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
